import dayjs from 'dayjs';

export default {
  formatCPF(value) {
    return value ? value?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4') : null;
  },
  validateCPF(value) {
    const reg = /^(\d{3}\.){2}\d{3}-\d{2}$/;
    return reg.test(value);
  },
  removeFormat(value) {
    return value ? value.replaceAll(/[^a-zA-Z0-9]/g, '') : null;
  },
  formatDate(data) {
    if (data) {
      const partesData = data?.split('/');
      const dia = partesData[0];
      const mes = partesData[1];
      const ano = partesData[2];
      return `${ano}-${mes}-${dia}`;
    } else {
      return null;
    }
  },
  formatBRDate(data) {
    return data ? dayjs(data).format('DD/MM/YYYY') : null;
  },
  formatBRDateHora(data)  {
    return data ? dayjs(data).format("DD/MM/YYYY HH:mm:ss") : null;;
  },
  formatDataBr(dataIso) {
    const [ano, mes, dia] = dataIso.split('-');
    return `${dia}/${mes}/${ano}`;
  },
  formatCEP(value) {
    return value ? value?.replace(/^(\d{5})(\d)/, '$1-$2') : null;
  },

  isValidDate(dateString) {
     const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;

    const match = dateString?.match(regex);
    if (!match) {
      return false;
     }
     const [, day, month, year] = match.map(Number);

     if (month < 1 || month > 12 || day < 1 || day > 31) {
        return false;
     }

     const date = new Date(year, month - 1, day);

    return (
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day
    );
  },
  MonetaryFormat(value: any, decimal: number = 2) {
    if (!value) return "0,00";

    // Converte para número e formata com casas decimais
    const number = Number(value);
    if (!isNaN(number)) {
      return number
        .toFixed(decimal)
        .replace(".", ",")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    } else {
      return value;
    }
  },

  IntegerFormat(value: any, decimal: number = 2) {
    if (!value) return "0";

    const number = Number(value);
    if (isNaN(number)) return "0";

    // Verifica se é inteiro
    const isInteger = number % 1 === 0;

    // Define o número de casas decimais: 0 se for inteiro, senão usa o valor padrão
    const formatted = number
      .toFixed(isInteger ? 0 : decimal) // 0 casas se inteiro
      .replace(".", ",") // separador decimal
      .replace(/\B(?=(\d{3})+(?!\d))/g, "."); // separador de milhar

    return formatted;
  },

  IntegerFormatTextField(value: any, decimal: number = 2) {
    const number = Number(value.replaceAll(".", "")); // Remove separadores de milhar

    if (isNaN(number)) {
      return "";
    }
    // Verifica se é inteiro
    const isInteger = number % 1 === 0;
    // Define o número de casas decimais: 0 se for inteiro, senão usa o valor padrão
    const formatted = number
      .toFixed(isInteger ? 0 : decimal) // 0 casas se inteiro
      .replace(".", ",") // separador decimal
      .replace(/\B(?=(\d{3})+(?!\d))/g, "."); // separador de milhar
    return formatted;
  },
};